"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./Tabs.scss");
var defaultContext = {
    tabs: [],
    activeTab: null,
    onChange: function () { return undefined; },
    switches: {},
    tabErrors: {},
};
var TabsContextWrapper = react_1.createContext([
    defaultContext,
    function () { },
]);
function hasChildren(tab) {
    return tab.children && tab.children.length > 0
        ? true
        : false;
}
function walkTabs(tabs) {
    if (tabs === void 0) { tabs = []; }
    var usableTabs = [];
    var switches = {};
    for (var _i = 0, tabs_1 = tabs; _i < tabs_1.length; _i++) {
        var tab = tabs_1[_i];
        if (typeof tab.enabled !== 'undefined' && !tab.enabled) {
            continue;
        }
        var usableTab = {
            label: tab.label,
            activeIdentifiers: [tab.identifier || ''],
            hasChildren: false,
            identifier: tab.identifier || '',
            children: [],
            enabled: true,
        };
        switches[usableTab.identifier] = true;
        if (hasChildren(tab)) {
            var children = (tab.children || []).map(function (child) {
                return __assign(__assign({}, child), { enabled: typeof child.enabled === 'undefined' || child.enabled });
            });
            children.forEach(function (child) { return (switches[child.identifier] = child.enabled); });
            usableTab.children = children.filter(function (child) { return child.enabled; });
            usableTab.identifier = tab.children[0].identifier;
            usableTab.hasChildren = true;
            usableTab.activeIdentifiers = tab.children.map(function (child) { return child.identifier; });
        }
        usableTabs.push(usableTab);
    }
    return [usableTabs, switches];
}
var Tabs = function (_a) {
    var children = _a.children, _b = _a.tabs, tabs = _b === void 0 ? [] : _b, onChange = _a.onChange;
    var _c = walkTabs(tabs), initialTabs = _c[0], switches = _c[1];
    var _d = react_1.useState({
        tabs: initialTabs,
        activeTab: initialTabs.length > 0 ? initialTabs[0].identifier : null,
        onChange: onChange ? onChange : function () { },
        switches: switches,
        tabErrors: {},
    }), state = _d[0], setState = _d[1];
    react_1.useEffect(function () {
        setState(function (cur) {
            var _a = walkTabs(tabs), gen = _a[0], switches = _a[1];
            var active = !cur.activeTab && gen.length > 0 ? gen[0].identifier : cur.activeTab;
            return __assign(__assign({}, cur), { switches: switches, tabs: gen, activeTab: active });
        });
    }, [tabs]);
    return (react_1.default.createElement(TabsContextWrapper.Provider, { value: [state, setState] },
        react_1.default.createElement("div", { className: "tabs" }, children)));
};
exports.useTabsContext = function () {
    var _a = react_1.useContext(TabsContextWrapper), state = _a[0], setState = _a[1];
    var tabs = state.tabs, switches = state.switches, tabErrors = state.tabErrors, activeTab = state.activeTab;
    var setActiveTab = react_1.useCallback(function (tab) {
        setState(function (cur) {
            var newState = __assign(__assign({}, cur), { activeTab: tab });
            state.onChange(tab, cur.activeTab);
            return newState;
        });
    }, []);
    var isActiveTab = react_1.useCallback(function (identifiers) {
        return state.activeTab ? identifiers.indexOf(state.activeTab) > -1 : false;
    }, [state.activeTab]);
    var setTabError = react_1.useCallback(function (identifier, hasError) {
        return setState(function (s) {
            var _a;
            return (__assign(__assign({}, s), { tabErrors: __assign(__assign({}, s.tabErrors), (_a = {}, _a[identifier] = hasError, _a)) }));
        });
    }, []);
    return { tabErrors: tabErrors, tabs: tabs, activeTab: activeTab, switches: switches, setActiveTab: setActiveTab, isActiveTab: isActiveTab, setTabError: setTabError };
};
exports.default = Tabs;
//# sourceMappingURL=Tabs.js.map